export default __webpack_public_path__ + "images/7c6970d78d176d42d26adba47091709f-longhauler.png";